module.exports = __webpack_public_path__ + "static/media/0018.3327a8eb.svg";